/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  Stack,
  HStack,
  Text,
  Spinner,
  VStack,
  Image,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { SearchTeamCard } from 'v4/components/team/search-listing-card';
import { SearchContext } from '../../context';
import { SearchCardSkeleton } from '../../search-card-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isMobile } from 'react-device-detect';
export const SearchTeamsListing = forwardRef(
  ({ count = 0, listing, isMainList, ...props }, ref) => {
    const {
      teamsSearchListing,
      refetchTeamsSearch,
      teamsSearchIsFetching,
      search,
      activeTab,
      teamsFetchNextPage,
      teamsHasNextPage,
      teamsTotalCount,
      teamsSearchIsLoading,
    } = useContext(SearchContext);

    useEffect(() => {
      if (!listing && activeTab === 'team') {
        refetchTeamsSearch?.();
      }
    }, [search, activeTab, listing]);

    const list = listing ?? teamsSearchListing;

    // console.log('teamsTotalCount', teamsTotalCount)

    return (
      <Stack mx={isMobile&&"auto"} w={isMobile?"100%":"100%"} mt={2} spacing={4} px={3}>
        {isMainList && list?.length > 0 ? (
          <>
            {list?.map?.((li, liIndex) => (
              <Card
              border="1px solid #D4D4D4"
              borderRadius="20px" 
              // boxShadow="0px -1px 6.3px 0px #00000030"
                 flex={1}
                 p={4}
                 key={liIndex}

                 mb={4}
                 w={isMobile?"96%":"500px"}
                m={2}
              >
                <SearchTeamCard team={li} />
              </Card>
            ))}
          </>
        ) : (
          <>
            {teamsSearchIsLoading ? (
              <SearchCardSkeleton />
            ) : (
              <>
                {teamsTotalCount > 0 ? (
                  <InfiniteScroll
                    dataLength={list?.length}
                    next={teamsFetchNextPage}
                    hasMore={teamsHasNextPage}
                    loader={
                      <HStack p={4} justifyContent="center" w="100%">
                        <Spinner />
                      </HStack>
                    }
                    // endMessage={
                    //   <Text style={{ textAlign: 'center' }}>
                    //     Yay! You have seen it all
                    //   </Text>
                    // }
                  >
                    {list?.map?.((li, liIndex) => (
                      <Card
                        border="1px solid #D4D4D4"
                     
                     boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06)"
                        flex={1}
                        p={4}
                        key={liIndex}
                        mb={4}
                        w={!isMobile?"500px":"100%"}
                        borderRadius="20px"
                      >
                        <SearchTeamCard team={li} refetchTeamsSearch={refetchTeamsSearch} />
                      </Card>
                    ))}
                  </InfiniteScroll>
                ) : (
                  <VStack
                justifyContent="center"
                alignItems="center"
                h="calc(80vh - 64px)"
              >
                <Image
                    src="/images/defaultSearchImage.svg"
                    alt="default Image"
                    width={["80%", "400px"]}
                  />
                <Text fontSize="18px" color="#AFAFAF" fontWeight="500">No results found</Text>
                <Text fontSize="14px" color="#AFAFAF" fontWeight="500">Try shortening or rephrasing your search.</Text>
              </VStack>
                )}
              </>
            )}
          </>
        )}
      </Stack>
    );
  }
);
